import axios, { AxiosError, AxiosInstance } from 'axios';
import _get from 'lodash/get';
import { ERROR_CODE } from './constants';

const DOMAIN_HEADER = 'x-shopback-domain';

class APIClient {
  client: AxiosInstance;

  defaultHeaders: object;

  constructor() {
    this.defaultHeaders = {
      'Content-Type': 'application/json',
      [DOMAIN_HEADER]: process.env.REACT_APP_DOMAIN,
    };
    this.client = axios.create({
      headers: this.defaultHeaders,
      withCredentials: true,
      baseURL: `${process.env.REACT_APP_API_URL}/sbgo-merchant-platform-information-service`,
    });
  }

  async postRequest(path: string, options = {}, errorCallback = (error: AxiosError) => {}, dataPath = 'data.data') {
    try {
      const response = await this.client.post(path, options);
      const data = _get(response, dataPath);
      return data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return errorCallback(error);
      }
      return ERROR_CODE.CONNECTION;
    }
  }
}

const client = new APIClient();

export default client;
